import React from "react";

const Contact = ()=> {
    return (
        <>
        <div className="about-banner px-20 py-20 flex justify-center items-center">
                <h2 className="font-bold text-5xl text-center text-white absolute bottom-0 pb-14 z-10">Contact Us</h2>
            </div>
         <div className="py-10 px-10 container mx-auto">
        <div className="sec-heading pb-4">
            <h2 className="font-bold text-4xl text-neutral-700 pb-2">Get in touch</h2>
            <small className="text-xl text-neutral-600">Send us a message and we'll respond as soon as possible</small>
        </div>
        <div className="registration-form py-8 px-4 w-1/2 mx-auto bg-white rounded shadow text-left">
            <form>
            <div class="mb-4">
                        <label class="block text-grey-darker text-sm font-bold mb-2" for="name">Name</label>
                        <input class="appearance-none border rounded w-full py-2 px-3 text-grey-darker border-slate-300" id="name" type="text" placeholder="Your name" />
                    </div>
                <div class="mb-4">
                    <label class="block text-grey-darker text-sm font-bold mb-2" for="email">Email</label>
                    <input class="appearance-none border rounded w-full py-2 px-3 text-grey-darker border-slate-300" id="email" type="email" placeholder="Your email" />
                </div>
                <div class="mb-4">
                    <label class="block text-grey-darker text-sm font-bold mb-2" for="email">Email</label>
                    <input class="appearance-none border rounded w-full py-2 px-3 text-grey-darker border-slate-300" id="email" type="tel" placeholder="Phone No." />
                </div>
                <div class="mb-4">
                    <label class="block text-grey-darker text-sm font-bold mb-2" for="message">Message</label>
                    <textarea class="appearance-none border rounded w-full py-2 px-3 text-grey-darker border-slate-300" id="message" type="text" placeholder="Message" />
                </div>
                <div className="flex items-center gap-4">
                    <div className="w-1/2">
                        <button type="submit" className="bg-blue-700 text-white px-4 py-3 rounded-lg">Contact us</button>
                    </div>
                </div>
            </form>
        </div>
        </div>
        </>
    )
}
export default Contact;